<template>
    <div>
        <div class="table-layout">
            <el-table :height="500+'px'" :data="callBidDocAuditList" border style="width: 100%">
                <el-table-column prop="auditState" label="状态" width="200">
                    <template slot-scope="rows">
                        <span v-if="rows.row.auditState == -1">未通过</span>
                        <span v-if="rows.row.auditState == 0">未审核</span>
                        <span v-if="rows.row.auditState == 1">通过</span>
                    </template>
                </el-table-column>
                <el-table-column prop="auditTime" label="时间" width="200"></el-table-column>
                <el-table-column prop="auditorName" label="审核人" width="180"></el-table-column>
                <el-table-column prop="auditDesc" label="描述"></el-table-column>
            </el-table>
        </div>

    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import callBidApi from '../../api/callBid'

    export default {
        name: 'swb-call-bid-doc-audit-list',
        desc: '招标书审核列表',
        props: ['id'],
        data: function () {
            return {
                callBidDocAuditList: [],
            }
        },
        created: function () {
            this.getCallBidDocAuditList();
        },
        methods: {

            getCallBidDocAuditList: function () {
                let self = this;
                let docId = self.id;
                //
                callBidApi.getBidDocAuditList(docId, function (result) {
                    if(result.type === "info") {
                        self.callBidDocAuditList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        },
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidDocAuditList.vue